import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Home from "../src/pages/Home";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ImageGallery from "./pages/ImageGallery";
import SchoolDetails from "./pages/SchoolDetails";
import TermsOfUse from "./pages/TermsOfUse";
import Login from "./pages/Login";
import StudentProfile from "./pages/StudentProfile";
import StudentProfileDetails from "./pages/StudentProfileDetails";
import Footer from "./pages/footer";
import SocialMediaLinks from "./pages/SocialMediaLinks";
import logoWithName from "../src/assets/images/logoLight.webp";
import logoWithNameScrolled from "../src/assets/images/logoWithName.webp";
import "./App.css";

function App() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const isHomePage = location.pathname === "/";

  const shouldHideNavAndFooter =
    location.pathname.includes("/terms-of-use") ||
    location.pathname.includes("/student-login") ||
    location.pathname.includes("/student-profile") ||
    location.pathname.includes("/student-profile-details") ||
    location.pathname.includes("/links/");

  useEffect(() => {
    if (!isHomePage) {
      setScrolled(true); // Always scrolled-style for non-home pages
      return;
    }

    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  return (
    <div>
      {!shouldHideNavAndFooter && (
        <Navbar
          expand="lg"
          className={`fixed-top custom-navbar ${scrolled ? "scrolled" : ""}`}
        >
          <Container>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="d-flex align-items-center py-2">
                <img
                  src={scrolled ? logoWithNameScrolled : logoWithName}
                  alt="Logo"
                  style={{ height: "7vh", transition: "all 0.3s ease" }}
                  className="me-2"
                />
              </div>
              <div className="d-flex justify-content-end">
                <div className="wooden-board">
                  <h5
                    className={`mb-0 text-on-board ${
                      scrolled ? "scrolled-text" : ""
                    }`}
                  >
                    Dashboard for Preschools
                  </h5>
                </div>
              </div>
            </div>
          </Container>
        </Navbar>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<ImageGallery />} />
        <Route path="/:schoolKey" element={<SchoolDetails />} />
        <Route path="/terms-of-use/:schoolKey" element={<TermsOfUse />} />
        <Route path="/links/:schoolKey" element={<SocialMediaLinks />} />
        <Route path="/student-login/:schoolKey" element={<Login />} />
        <Route
          path="/student-profile/:schoolKey/:syncId"
          element={<StudentProfile />}
        />
        <Route
          path="/student-profile-details/:schoolKey/:syncId/:kidId"
          element={<StudentProfileDetails />}
        />
      </Routes>

      {!shouldHideNavAndFooter && <Footer />}
    </div>
  );
}

export default App;
